import { render, staticRenderFns } from "./DL.vue?vue&type=template&id=78608a4e&scoped=true"
import script from "./DL.vue?vue&type=script&lang=js"
export * from "./DL.vue?vue&type=script&lang=js"
import style0 from "./DL.vue?vue&type=style&index=0&id=78608a4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78608a4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78608a4e')) {
      api.createRecord('78608a4e', component.options)
    } else {
      api.reload('78608a4e', component.options)
    }
    module.hot.accept("./DL.vue?vue&type=template&id=78608a4e&scoped=true", function () {
      api.rerender('78608a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/front/Candidate/Resume/DL.vue"
export default component.exports